module.exports = __webpack_public_path__ + "fbc4c86ec137778eb17b92db074afdf0.svg";